
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/share/visitor/[sangjuKey]",
      function () {
        return require("private-next-pages/share/visitor/[sangjuKey].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/share/visitor/[sangjuKey]"])
      });
    }
  